<template>
  <label class="btn btn-secondary has-checked:bg-primary has-checked:border-primary has-checked:text-white">
    <input
      type="checkbox"
      class="hidden"
      v-model="model"
      :value="value"
    />
    <slot />
  </label>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: [Array, String, Boolean] },
  value: { type: [String, Boolean] },
});

const emit = defineEmits(['update:modelValue']);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>
